import { EstablishmentCategory } from '@/modules/accredited-establishments/api/types'

interface CategoryChipOption {
  label: string
  value: EstablishmentCategory
}

/** Order and labels come from the handoff, not from the API enum. */
const CATEGORY_CHIP_OPTIONS: CategoryChipOption[] = [
  { label: 'Hospitais', value: 'HOSPITAL' },
  { label: 'Laboratórios', value: 'LABORATORY' },
  { label: 'Especialistas', value: 'SPECIALIST' },
  { label: 'Maternidades', value: 'MATERNITY' },
  { label: 'Pronto-socorros', value: 'EMERGENCY_UNITY' }
]

export { CATEGORY_CHIP_OPTIONS }
export type { CategoryChipOption }
